import { useQuery } from "@tanstack/react-query";

import { instatusQueries } from "@/api/resources/instatus/queries";

export const useInstatusStatus = () => {
  return useQuery(instatusQueries.all());
};
